<template>
  <v-layout>
    <v-flex class="margin">
      <loading :isLoading="isLoading" />
      <snackbar />
      <!-- mobile -->
      <div v-if="mobileView" id="e3" style="max-width: 800px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>แอดมิน</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex md9>
                <span class="texefild-mobile">ค้นหาโดยข้อความ : </span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 align-center py-3 v-if="mobileView">
                <v-text-field color="#0f4898" solo light label="search" hide-details v-model="searchAdmin"
                  append-icon="search" style="width: 90%; margin-left: 20px; margin-right: 20px">
                </v-text-field>
              </v-flex>
            </v-layout>

            <!-- add admin dialog -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn outline fab color="#0f4898" dark v-on="on" small>
                  <v-icon dark>mdi-account-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Add Admin</strong></span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="addmail" prepend-icon="mdi-email" v-model="addMail" label="E-mail"
                          color="#0f4898" :rules="[() => !!addMail || 'This field is required']"
                          required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="save"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- edit dialog -->
            <v-dialog v-model="dialog2" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Edit Admin</strong></span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="editMail" prepend-icon="mdi-email" v-model="newEmail" label="E-mail"
                          color="#0f4898"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog2 = false"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="edit"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
              <v-card>
                <v-card-title class="headline" style="color: #0f4898;"><strong>Delete Admin</strong></v-card-title>
                <v-card-text>Are you sure you want to delete this admin?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialogConfirm = false"
                    style="border-radius: 5px; border: 1px solid #000; background-color: transparent; color: #000;">
                    No</v-btn>
                  <v-btn @click="deleteItem"
                    style="border-radius: 5px; border: 1px solid #1976d2; background-color: transparent; color: #1976d2;">
                    OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="adminList" class="elevation-1" :search="searchAdmin"
              disable-initial-sort id="mytable">
              <template v-slot:items="props">
                <td>{{ props.index + 1 }}</td>
                <td v-if="props.item.email == null" class="text-xs-left grey--text">Not logged in yet</td>
                <td v-else class="text-xs-left">{{ props.item.email }}</td>
                <td class="justify-center layout px-0">
                  <v-icon small color="#0f4898" class="mr-2" @click="editItem(props.item.email, '')">
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="dialogDel(props.item.email)">
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </div>


      <!-- web -->
      <div v-if="!mobileView" id="e3" style="max-width: 1500px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>แอดมิน</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <!-- add admin dialog -->
            <v-container fluid>
              <!-- Layout หลัก -->
              <v-layout justify-space-between align-center>
                <!-- ปุ่มเพิ่มร้านค้าอยู่ซ้าย -->
                <v-flex shrink>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn outline fab color="#0f4898" dark v-on="on" small
                        style="margin-bottom: -10px; margin-left: -10px;">
                        <v-icon dark>mdi-account-plus</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline" style="color: #0f4898;"><strong>Add Admin</strong></span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field ref="addmail" prepend-icon="mdi-email" v-model="addMail" label="E-mail"
                                color="#0f4898" :rules="[() => !!addMail || 'This field is required']"
                                required></v-text-field>
                            </v-flex>

                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="close"
                          style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                          Cancel
                        </v-btn>
                        <v-btn @click="save"
                          style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>

                <!-- ค้นหาอยู่ขวา -->
                <v-layout justify-end align-center>
                  <!-- ข้อความชิดขวา -->
                  <span class="texefild-mobile" style="margin-right: 8px;">ค้นหาโดยข้อความ :</span>

                  <!-- ช่องค้นหาชิดขวา -->
                  <v-flex md3>
                    <v-text-field color="#0f4898" solo light label="search" hide-details v-model="searchAdmin"
                      append-icon="search"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>


            <!-- edit dialog -->
            <v-dialog v-model="dialog2" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Edit Admin</strong></span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="editMail" prepend-icon="mdi-email" v-model="newEmail" label="E-mail"
                          color="#0f4898"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog2 = false"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="edit"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
              <v-card>
                <v-card-title class="headline" style="color: #0f4898;"><strong>Delete Admin</strong></v-card-title>
                <v-card-text>Are you sure you want to delete this admin?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialogConfirm = false"
                    style="border-radius: 5px; border: 1px solid #000; background-color: transparent; color: #000;">
                    No</v-btn>
                  <v-btn @click="deleteItem"
                    style="border-radius: 5px; border: 1px solid #1976d2; background-color: transparent; color: #1976d2;">
                    OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="adminList" class="elevation-1" :search="searchAdmin"
              disable-initial-sort id="mytable">
              <template v-slot:items="props">
                <td>{{ props.index + 1 }}</td>
                <td v-if="props.item.email == null" class="text-xs-left grey--text">Not logged in yet</td>
                <td v-else class="text-xs-left">{{ props.item.email }}</td>
                <td class="justify-center layout px-0">
                  <v-icon small color="#0f4898" class="mr-2" @click="editItem(props.item.email, '')">
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="dialogDel(props.item.email)">
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </div>

    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import { sync } from 'vuex-pathify'
moment.locale('en')
export default {
  data() {
    return {
      dialog: false,
      dialog2: false,
      dialogConfirm: false,
      account_id: this.$cookies.get('account_id'),
      addMail: '',
      editMail: '',
      currentId: {},
      delelteEmail: '',
      searchAdmin: '',
      adminList: [],
      mydropdown: ['Admin'],
      newEmail: "", // เพิ่มตัวแปรนี้เพื่อเก็บค่าอีเมลใหม่
      headers: [
        {
          text: 'No.',
          align: 'left',
          sortable: false,
          value: 'no'
        },
        { text: 'E-mail', align: 'left', value: 'email' },
        { text: 'Action', align: 'center', value: 'action', sortable: false }
      ],
      editedItem: {
        email: '',
      },
      defaultItem: {
        email: '',
      }
    }
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset()
      })
    },
    async checkField() {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true
        this.dialogloader = false
        this.$refs[f].validate(true)
      })

    },
    handleView() {
      this.mobileView = window.innerWidth <= 990
    },
    async getadmin() {
      try {
        this.istableloading = true
        var { data } = await this.axios.get(`${process.env.VUE_APP_APIHOST}/admin/all`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.adminList = data.data

        // console.log(this.account_id)
        this.istableloading = false
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    editItem(email) {
      this.currentId = { email: email }; // เก็บ email ที่จะทำการแก้ไข
      this.newEmail = email; // ตั้งค่า newEmail ให้เป็น email ปัจจุบัน
      this.dialog2 = true;  // เปิด dialog
    },

    async dialogDel(item) {
      this.delelteEmail = item
      this.dialogConfirm = true
      // console.log(this.delelteEmail)
    },
    async deleteItem() {
      this.istableloading = true
      // this.delelteEmail = item
      // confirm('Are you sure you want to delete this email?')
      // alert('Are you sure you want to delete this email?')
      let { data } = await this.axios.delete(`${process.env.VUE_APP_APIHOST}/admin/delete`,
        {
          data: { email: this.delelteEmail }, // Ensure email is sent in the body
          headers: { Authorization: this.$cookies.get('token') }
        })
      window.location.reload()
      //  && this.adminList.splice(index, 1)
    },
    close() {
      this.clearForm()
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async save() {
      this.istableloading = true;

      if (!this.formHasErrors) {  // ตรวจสอบว่าไม่มี error
        try {
          let { data } = await this.axios.post(`${process.env.VUE_APP_APIHOST}/admin/register`,
            {
              email: this.addMail,
              createdBy: this.$cookies.get('firstname')
            }, {
            headers: { Authorization: this.$cookies.get('token') }
          });

          window.location.reload();

        } catch (error) {
          console.error(error);
          alert('An error occurred while saving.');  // แจ้งเตือนข้อผิดพลาดจากการเชื่อมต่อ
        }
      }
    },

    async edit() {
      this.istableloading = true;
      try {
        // Send the PUT request to update the user's data
        let { data } = await this.axios.put(`${process.env.VUE_APP_APIHOST}/admin/edit`, {
          email: this.currentId.email,
          newEmail: this.newEmail,
          createdBy: this.$cookies.get('firstname')
        }, {
          headers: { Authorization: this.$cookies.get('token') }
        });

        if (data.success) {
          // If update is successful, reload the page or close dialog
          window.location.reload();
        }
        window.location.reload();

      } catch (error) {
        console.error(error);
        alert('An error occurred while updating the user.');
      } finally {
        this.istableloading = false;
      }
    }


  },
  created() {
    this.getadmin()
    this.handleView()
    window.addEventListener('resize', this.handleView)
  },
  computed: {
    form() {
      return {
        addmail: this.addMail,
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  }
}
</script>
